var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error)?_c('div',{staticClass:"uk-animation-fade"},[_c('InfoBox',{attrs:{"mode":"danger"}},[_c('ErrorMessageString',{attrs:{"error":_vm.error,"custom-errors":_vm.customErrors}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }